module.exports = __webpack_public_path__ + "img/templateMini.7b17cf53.png";